<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">아이템 분류 설정</h2>
      <div class="innerContent">
        <div class="addCategory">
          <button type="button" class="btn btnWhite btnAdd" @click="addItem"></button>
        </div>
        <draggable
          tag="div"
          :list="classList"
          handle=".btnHandle"
          animation="300"
          class="categoryTree">
          <transition-group type="transition"
            tag="div">
            <div
              v-for="item in classList"
              :key="item.collectionClassId"
              class="item">
              <div class="itemWrap">
                <div class="itemInfo">
                  <SetLanguageValue class="categoryName"
                    :locale="locale"
                    :langValue="item.collectionClassName" />
                  <div class="checkbox">
                    <input type="checkbox" :id="`is_required_class_${item.collectionClassId}`" v-model="item.isRequired" />
                    <label :for="`is_required_class_${item.collectionClassId}`">필수</label>
                  </div>
                  <button
                    type="button"
                    class="btnDel"
                    @click="removeItem(item.collectionClassId)"></button>
                </div>
                <button
                  type="button"
                  class="btnHandle"></button>
              </div>
            </div>
          </transition-group>
        </draggable>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" @click="save">{{ locale.save }}</button>
      </div>
    </div>
    <!-- 언어별 세팅 -->
    <!-- <LangValue v-show="langValueLayer"
      :locale="locale"
      :langValue="langValue"
      :title="locale.language_specific_set"
      @close="closeLanguage" /> -->
    <!-- //언어별 세팅 -->
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import SetLanguageValue from '@/components/Util/SetLanguageValue'

export default {
  name: 'CollectionItemClasses',
  props: [
    'locale',
    'defaultLang',
    'collectionGroup'
  ],
  components: {
    draggable,
    SetLanguageValue,
  },
  computed: {
  },
  data () {
    let useCollectionGroup = this.collectionGroup?.use === true
    let classList = this._.cloneDeep(this.collectionGroup?.collectionClasses || [])
    return {
      useCollectionGroup,
      classList,
      langTarget: null,
      langValueLayer: false,
      langValue: {},
    }
  },
  methods: {
    addItem () {
      const classItem = {
        collectionClassId: UNIQUE.uniqueId8(),
        collectionClassName: LANG.valueObj(''),
        isRequired: true
      }
      this.classList.push(classItem)
    },
    removeItem (classId) {
      this.classList = this.classList.filter(item => item.collectionClassId !== classId)
    },
    setLanguage (classId, className) {
      const fillLangs = UTIL.fillLangs(className, className[this.defaultLang])
      className = fillLangs
      this.langTarget = classId
      this.langValueLayer = true
      this.langValue = className
    },
    closeLanguage () {
      const classId = this.langTarget
      const targetItem = this.classList.find(item => item.collectionClassId === classId)
      
      if (targetItem) {
        targetItem.collectionClassName = this.langValue
      }
      this.langTarget = null
      this.langValueLayer = false
      this.langValue = {}
    },
    close () {
      this.$emit('close')
    },
    save () {
      const useCollectionGroup = {
        use: this.useCollectionGroup,
        collectionClasses: this.classList
      }
      this.$emit('save', useCollectionGroup)
    }
  }
}
</script>

<style lang="scss" scoped>
.layer .inner {
  max-width: 400px;
}
.addCategory {
  .btnAdd {
    background-color: $color-white;
  }
}
.innerContent {
  flex: 1;
  overflow: auto;
}
.categoryTree {
  .item {
    margin-bottom: 8px;
  }
  .itemWrap {
    display: flex;
  }
  .btnHandle {
    position: relative;
    width: 36px;
    border: 1px solid $color-lgrey2;
    border-left: none;
    border-radius: 0 4px 4px 0;
    background: $bg-default;
    cursor: move;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/img/move.png') 50% 50% / 16px no-repeat;
      opacity: 0.2;
    }
  }
  .itemInfo {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0 0 0 12px;
    border: 1px solid $color-lgrey2;
    border-radius: 4px 0 0 4px;
    background-color: $color-white;
    button {
      width: 36px;
      height: 36px;
      font-size: 0;
      &:before {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background: url('~@/assets/img/ico_arrow.svg') 50% 50% / 16px no-repeat;
        opacity: 0.4;
      }
    }
    .btnDel {
      height: 100%;
      &:before {
        background: url('~@/assets/img/ico_close_black.svg') calc(100% - 8px) 8px / 16px no-repeat;
        opacity: 0.2;
      }
    }
    .categoryName {
      flex: 1;
      margin: 4px;
    }
    .checkbox {
      margin-left: 8px;
      margin-right: 0;
    }
  }
}
</style>
